/** Identifiers for behaviour settings CSV import targets. */
const UPLOAD_KIND = Object.freeze({
  CORE_VALUE: "coreValue",
  POSITIVE_BEHAVIOUR: "positiveBehaviour"
})

/** POST — `apiV8nocache` base is already `/api/v8`. */
const PBIS_CSV_UPLOAD_API_PATH = "/admin/pbis/positive-behaviors/upload"

const PBIS_CSV_UPLOAD_SAMPLE_PATH =
  "/csv-samples/behaviour-pbis-upload-sample.csv"

/**
 * Single source of truth for CSV upload modals.
 * Core value and positive behaviour uploads share the same API and CSV format.
 */
const UPLOAD_DEFINITIONS = Object.freeze({
  [UPLOAD_KIND.CORE_VALUE]: {
    inputId: "behaviour-core-value-csv-upload",
    sampleFilePath: PBIS_CSV_UPLOAD_SAMPLE_PATH,
    uploadApiPath: PBIS_CSV_UPLOAD_API_PATH,
    uploadSuccessAction: "coreValuesCsvUploaded",
    titleI18nKey: "behaviour_settings.upload_core_value_csv_title",
    fileLabelI18nKey: "behaviour_settings.upload_csv_file_label_core_value",
    testId: "behaviour-core-value-csv-upload-form"
  },
  [UPLOAD_KIND.POSITIVE_BEHAVIOUR]: {
    inputId: "behaviour-positive-behaviours-csv-upload",
    sampleFilePath: PBIS_CSV_UPLOAD_SAMPLE_PATH,
    uploadApiPath: PBIS_CSV_UPLOAD_API_PATH,
    uploadSuccessAction: "positiveBehavioursCsvUploaded",
    titleI18nKey: "behaviour_settings.upload_positive_behaviours_csv_title",
    fileLabelI18nKey:
      "behaviour_settings.upload_csv_file_label_positive_behaviours",
    testId: "behaviour-positive-behaviours-csv-upload-form"
  }
})

const UPLOAD_KIND_VALUES = Object.freeze(Object.values(UPLOAD_KIND))

export default {
  UPLOAD_KIND,
  UPLOAD_DEFINITIONS,
  UPLOAD_KIND_VALUES
}
